import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractInputComponent } from '../abstract-input.component';
import {
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyInputComponent } from '../empty-input/empty-input.component';

@Component({
  selector: 'common-number-input',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    EmptyInputComponent,
    FormsModule,
  ],
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss'],
})
export class NumberInputComponent extends AbstractInputComponent {
  @Input()
  public min: number;

  @Input()
  public max: number;

  @Output()
  public itemChange: EventEmitter<number> = new EventEmitter<number>();

  protected override createValidators(): ValidatorFn[] {
    const validators = super.createValidators();
    if (this.max !== undefined) {
      validators.push(Validators.max(this.max));
    }
    if (this.min !== undefined) {
      validators.push(Validators.min(this.min));
    }
    return validators;
  }

  public onInputChange(event: Event): void {
    if (this.min && this.item < this.min) {
      this.item = this.min;
    }
    if (this.max && this.item > this.max) {
      this.item = this.max;
    }

    this.itemChange.emit(this.item);
  }
}
